import { findVirginiaPlace } from '@vigeo/shared';
import { PICK_PLACE_AGAIN } from './PlacePicker.js';

/**
 * The words for a place, read from the app's own list of Virginia places by the place's code (ADR-021 section 2, #594).
 *
 * NOTHING IS ASKED OF ANYONE. The list arrives with the page (`@vigeo/shared`), so a name is there on the first draw:
 * there is no "loading" and no "unavailable", and this file imports nothing that can make a request.
 *
 * A CODE THAT IS NOT IN THE LIST is one of Google's place ids, saved before the list existed (ADR-021 section 7). It has
 * no name here and nobody is asked for one: it reads `PICK_PLACE_AGAIN`, the picker's own words for it (#593), so the
 * form and the Roster cannot say two different things.
 */

export { PICK_PLACE_AGAIN };

/**
 * A listed place's words: a city, town or community by its name ("Norfolk"), a ZIP code area as "ZIP" plus the number
 * ("ZIP 23220"). `undefined` when the code is not in the list, so a caller can leave such a place out (of a search, or
 * of the choices in a filter) instead of offering words that name nothing.
 */
export function listedPlaceWords(placeId: string): string | undefined {
  const listed = findVirginiaPlace(placeId);
  if (listed === undefined) return undefined;
  return listed.kind === 'zip' ? `ZIP ${listed.name}` : listed.name;
}

/** What a place reads on screen: its words from the list, or `PICK_PLACE_AGAIN`. */
export const placeWords = (placeId: string): string => listedPlaceWords(placeId) ?? PICK_PLACE_AGAIN;
